import React from 'react';
import RelayStore from '../RelayStore'
import ValidateUserMutation from '../mutations/User/ValidateUserMutation';
import UserItem from './UserItem';

class UserTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeLine: null
    }
  }

  _highlightLine = (index) => {
    this.setState({activeLine: index});
  }


  validateUser = (user, callback) => {
    user.isTrustedUserToCreateActivities = true;
    this.onValidateUser(user, callback);
  }

  unvalidateUser = (user, callback) => {
    user.isTrustedUserToCreateActivities = false;
    this.onValidateUser(user, callback);

  }

  onValidateUser = (user, callback) => {
    const viewer = this.props.viewer;
    let validatePublicActivities = user.isTrustedUserToCreateActivities;
    let validatePublicGroups = user.isTrustedUserToCreateCircles;

		let mutation = new ValidateUserMutation({viewer, user, validatePublicActivities, validatePublicGroups});

  	RelayStore.commitUpdate( mutation, {
      onFailure: (error) => {
        console.log('error', error.getError());
        alert('Update Failed');
      },
      onSuccess: (response) => {
        console.log('success', response);
        alert('Update Success');
        
        if (typeof callback !== 'undefined')
          callback()
      }
  	});
  }

  render() {
    const dataSource = this.props.dataSource;
    
    return (
      <table className="table table-hover table-condensed">
        <thead>
          <tr>
            <th>NO.</th>
            <th>Avatar</th>            
            <th>Pseudo</th>
            <th>Creation date</th>
            <th>Sex</th>
            <th>Status</th>
            <th>Reporters</th>
            <th>Pending certificates</th>
            <th>Auto validation users</th>
          </tr>
        </thead>

        <tbody>
          {dataSource.map((item, index, arr) => (
            <UserItem
              key={index}
              viewer={this.props.viewer}
              userId={item.id}
              index={index}
              isActiveLine={this.state.activeLine === index}
              _highlightLine={this._highlightLine}
              _switchButton={this._switchButton}
              filter={this.props.filter}
              validateUser={this.validateUser}
              unvalidateUser={this.unvalidateUser}
              onItemClick={this.props.onItemClick}
            />
          ))}
          
          {/* // this._renderItem(item.node, index))} */}
        </tbody>
      </table>
    )
  }


}

UserTable.propTypes = ({
  dataSource : React.PropTypes.array.isRequired,
  onItemClick: React.PropTypes.func.isRequired,
});




export default UserTable;


// WEBPACK FOOTER //
// ./src/components/UserTable.js